import { apiSlice } from "@/redux/apiSlice";

export const palletApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPallets: builder.query({
      query: (projectId) => `/projects/getAllPalletsForProject/${projectId}`,
    }),
    validatePalletConfig: builder.query({
      query: (projectId) => `/projects/validatePalletConfig/${projectId}`,
    }),
    getPalletDetails: builder.query({
      query: (palletId) => `/projects/getPalletDetails/${palletId}`,
      providesTags: (result, error, palletId) => [{ type: 'PalletDetails', palletId }],
    }),
    getFTLConsolidatedData: builder.query({
      query: ({ projectId, variant }) => `/projects/getFTLConsolidatedData/${projectId}/${variant}`,
    }),
    createPallet: builder.mutation<any, any>({
      query: (body) => ({
        url: '/projects/generatePallet',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PalletConfig'],
    }),
    updatePallet: builder.mutation<any, any>({
      query: (body) => ({
        url: '/projects/generatePallet',
        method: 'POST',
        body,
      }),
    }),
    createPalletDetails: builder.mutation<any, any>({
      query: (body) => ({
        url: '/projects/createPalletDetails',
        method: 'POST',
        body,
      }),
      //only invalidate if body.type is clone
      invalidatesTags: (result, error, body) => body.type === 'clone' ? ['PalletDetails', body.activePalletId] : ['PalletConfig'],
    }),
    deletePallet: builder.mutation<any, number>({
      query: (palletId) => ({
        url: `/projects/deletePallet/${palletId}`,
        method: 'POST',
      }),
      invalidatesTags: ['PalletConfig'],
    }),
  }),
});



export const {
  useGetPalletsQuery,
  useGetPalletDetailsQuery,
  useCreatePalletMutation,
  useUpdatePalletMutation,
  useCreatePalletDetailsMutation,
  useGetFTLConsolidatedDataQuery,
  useValidatePalletConfigQuery,
  useDeletePalletMutation
} = palletApiSlice;
